/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import { MdCircle } from 'react-icons/md';
import { getPriorityColor } from '../../../utils/api/site';
import { SITE_STATES } from '../../../constants/sites';
import { formatZipCode } from '../../../utils/zipCodeUtils'; // Adjust path as needed

const Site = ({ site }) => {
  const {
    id, name, address1, city, priority, state, zip_code,
  } = site;

  const stateObj = SITE_STATES.find(s => s.name.toLowerCase() === state.toLowerCase());
  const stateAbbrev = stateObj ? stateObj.value : state;
  const shortZip = formatZipCode(zip_code);

  const addressParts = [address1, city, stateAbbrev, shortZip].filter(Boolean);
  const formattedAddress = addressParts.join(', ');

  return (
    <a href={`/sites/${id}`} className="flex items-center gap-4 px-4 py-2 rounded-lg text-black bg-vamos-v-light-gray mb-2 hover:bg-vamos-light-gray">
      <MdCircle size={16} color={getPriorityColor(priority)} className="flex min-w-[3%] w-4 h-4 flex-none" />
      <h3 className="text-base font-semibold m-0 truncate mr-4 min-w-0 max-w-[60%]">{name}</h3>
      <p className="text-sm font-normal truncate flex-1">{formattedAddress}</p>
    </a>
  );
};

export default Site;

Site.propTypes = {
  site: PropTypes.object.isRequired,
};
